import * as actions from './actionTypes';


export interface IPriceListStore {
    priceList?: any
}

const INITIAL_STATE: IPriceListStore = {
    priceList: undefined
}

const PriceList = (state = INITIAL_STATE, action:{type: string, payload: any }) => {
    switch (action.type) {

        case actions.SET_PRICE_LIST_DEFAULT:
            state = {
                ...state,
                priceList: {...action.payload},
            }
            break;
        
        default:
            state = { ...state }
            break;
    }
    return state;
}

export default PriceList;